<template>
    <div>
        <card-header title="Edit Flight" icon="fa-plane-departure"/>

        <entity-tabs v-model="tab" main-label="Flight" main-icon="fa-plane-departure" :task-count="taskCount" :task-completed-count="taskCompleted" :note-count="noteCount"/>

        <card-toolbar v-show="tab === 'main'">
            <template #right>
                <button @click="$openCard('copy-flight', {registrationId: props.registrationId, flightId: props.flightId}, card)"><i class="fas fa-copy mr-2"/>Copy Flight</button>
            </template>
        </card-toolbar>

        <card-body>
            <entity-tasks-pane v-show="tab === 'tasks'" :card="card" :child="child" entity-type="flights" :entity-id="props.flightId" @count="taskCount = $event" @completed="taskCompleted = $event"/>
            <entity-notes-pane v-show="tab === 'notes'" :card="card" :child="child" entity-type="flights" :entity-id="props.flightId" @count="noteCount = $event"/>
            <div v-show="tab === 'main'">
            <card-list>
                <registration-list-item :card="card" :registration="registration" @click="$openCard('registration', {registrationId: registration.id}, card)"/>
            </card-list>
            <div class="notification is-info is-light py-2 px-3 is-size-7 mx-3 mt-3 mb-3" v-if="flight.flight_group_id">
                <div class="columns is-mobile is-vcentered">
                    <div class="column">
                        <i class="fas fa-link mr-2"></i><strong>Linked flight</strong> &mdash; flight detail changes (airline, flight number, airports, times) update {{ groupOthers.length }} other linked {{ groupOthers.length === 1 ? 'flight' : 'flights' }}:
                        <span v-for="(g, i) in groupOthers" :key="g.id">{{ g.last_name }}, {{ g.first_name }}<span v-if="g.trip_id !== registration.trip_id"> ({{ g.trip_title }})</span><span v-if="i < groupOthers.length - 1">; </span></span>.
                        Unlinking stops this flight from syncing with the others; deleting it removes it from this registration only.
                    </div>
                    <div class="column is-narrow">
                        <b-button size="is-small" type="is-info is-light" @click="unlinkFlight"><i class="fas fa-unlink"></i><span class="ml-2" v-if="confirmUnlink">Unlink?</span></b-button>
                    </div>
                </div>
            </div>
            <flight-form :flight="flight" :registration="registration" :itinerary="itinerary"/>
            </div>
        </card-body>

        <card-footer class="pt-3 pb-3" v-show="tab === 'main'">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteFlight"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Flight?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button type="is-primary" size="is-small" :disabled="!flight.depart_airport || !flight.arrive_airport || !flight.depart_date || !flight.depart_time || !flight.arrive_date || !flight.arrive_time || !flight.flight_number" @click="submit"><i class="fas fa-check mr-2"></i>Save Flight</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import {client as http} from '../../http_client';
    import CardHeader from '../../TIER/components/CardHeader';
    import CardBody from '../../TIER/components/CardBody';
    import CardFooter from '../../TIER/components/CardFooter';
    import FlightForm from './FlightForm';
    import RegistrationListItem from "../../components/RegistrationListItem";

    import async from 'async';
    import CardList from "../../TIER/components/CardList";
    import {mapActions} from "vuex";
    import CardToolbar from "../../TIER/components/CardToolbar.vue";
    import EntityTabs from "@/components/EntityTabs";
    import EntityTasksPane from "@/components/EntityTasksPane";
    import EntityNotesPane from "@/components/EntityNotesPane";

    export default {
        props: ['card', 'child', 'props'],
        components: {EntityNotesPane, EntityTasksPane, EntityTabs, CardToolbar, CardList, RegistrationListItem, CardFooter, CardBody, CardHeader, FlightForm},
        data: function() {
            return {
                flight: {},
                registration: {trip: {}, user: {}},
                itinerary: [],
                confirmDelete: false,
                confirmUnlink: false,
                dirty: null,
                tab: 'main',
                taskCount: 0,
                taskCompleted: 0,
                noteCount: 0
            };
        },
        computed: {
            groupOthers: function() {
                if (!this.flight.group_flights) return [];
                return this.flight.group_flights.filter(g => g.id !== this.flight.id);
            }
        },
        methods: {
            ...mapActions(['updateTasks']),
            loadFlight: function() {
                this.$emit('loading', true);
                this.dirty = null;

                async.series([
                    // Get flight
                    (cb) => {
                        http.get('/api/registrations/' + this.props.registrationId + '/flights/' + this.props.flightId, {force: true}).then(response => {
                            this.flight = response.data;
                            cb();
                        });
                    },
                    // Get registration
                    (cb) => {
                        http.get('/api/registrations/' + this.props.registrationId, {force: true}).then(response => {
                            this.registration = response.data;
                            cb();
                        });
                    },
                    // Get itinerary
                    (cb) => {
                        http.get('/api/registrations/' + this.props.registrationId + '/itinerary', {force: true}).then(response => {
                            this.itinerary = response.data.days;
                            cb();
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                });
            },
            submit() {
                this.$emit('loading', true);
                http.put('/api/registrations/' + this.props.registrationId + '/flights/' + this.props.flightId, this.flight, {force: true}).then(response => {
                    this.updateTasks();
                    this.$reloadCard('registrations');
                    this.$reloadCard('registration', {registrationId: this.props.registrationId});
                    this.$reloadCard('flights', {registrationId: this.props.registrationId});
                    this.$reloadCard('itinerary', {registrationId: this.props.registrationId});
                    this.$reloadCard('events', {dayId: this.props.dayId});
                    this.$reloadCard('tasks');
                    this.$reloadCard('task-details', {type: 'flights'});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            },
            unlinkFlight() {
                if (this.confirmUnlink) {
                    this.confirmUnlink = false;
                    this.$emit('loading', true);
                    http.post('/api/registrations/' + this.props.registrationId + '/flights/' + this.props.flightId + '/unlink', {}, {force: true}).then(response => {
                        this.loadFlight();
                    }).catch(err => {
                        this.$emit('loading', false);
                    });
                } else {
                    this.confirmUnlink = true;
                    setTimeout(() => {
                        this.confirmUnlink = false;
                    }, 3000);
                }
            },
            deleteFlight() {
                if (this.confirmDelete) {
                    http.delete('/api/registrations/' + this.props.registrationId + '/flights/' + this.props.flightId).then(response => {
                        this.$reloadCard('flights');
                        this.$reloadCard('tasks');
                        this.$reloadCard('task-details', {type: 'flights'});
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.flightId': function(newProps) {
                this.loadFlight();
            },
            'flight': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this flight? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadFlight();
        }
    };
</script>
